var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Main-Content",attrs:{"id":"SiteReportsLogin"}},[_c('Page',[(!_vm.error)?_c('LoadingLayout'):_c('Layout',[_c('LayoutSection',[_c('Card',[_c('CardSection',[_c('p',[_vm._v(_vm._s(_vm.error))])])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }